<template>
    <div>
        <!-- List header -->
        <a-row type="flex" :gutter="24">

            <a-col :span="12" class="mb-24">

			</a-col>

            <a-col :span="12" class="mb-24 text-right">
                <a-button @click="openCategoryAddModal" class="ml-15">
					<i class="ni ni-archive-2 mr-5"></i> ADD CATEGORY
				</a-button>
            </a-col>

        </a-row>
        <!-- / List header -->

        <!-- List card -->
        <a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: 0, paddingTop: '16px'}">
            <categories-list-view />
        </a-card>
        <!-- / List card -->

        <category-add-view-modal ref="categoryAddModal"/>

        

    </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import CategoriesListView from './CategoriesListView.vue'
import CategoryAddViewModal from './CategoryAddViewModal.vue'


export default {

    components : {
        CategoriesListView,
        CategoryAddViewModal
    },

    computed : {
        ...mapState({
            categories : state => state.products.categoriesFromProductsList
        }),
        ...mapGetters({
            
        })
    },
    data () {
        return {
            
        }
    },

    methods : {
        openCategoryAddModal() {

            this.$refs['categoryAddModal'].showModal();
            
        },
        async sleep(miliSeconds) {
            return new Promise(r => setTimeout(r, miliSeconds));
        },
    },

    async created () {
        this.$message.loading('Loading data...', 0);
        await this.$store.dispatch('categories/getCategoriesAction', { });
        await this.sleep(1000);
        this.$message.destroy();
    } 
}
</script>